(function () {
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  
  // Safe way to remove the blocker without using ?.
  function removeBlocker() {
    if (viewTransitionRenderBlocker) {
      viewTransitionRenderBlocker.remove();
    }
  }

  // Remove the view transition render blocker if the user has reduced motion enabled,
  // is on a low power device, or is in an Android Meta in-app browser.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice() || isMetaAndroidWebView()) {
    removeBlocker();
  } else {
    // If the browser didn't manage to parse the main content quickly, at least let the user see something.
    // We're aiming for the FCP to be under 1.8 seconds since the navigation started.
    const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - now);

    setTimeout(() => {
      removeBlocker();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      if (viewTransition) {
        viewTransition.skipTransition();
      }
      return;
    }

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          if (viewTransition) viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered ? transitionTriggered.getAttribute('data-view-transition-type') : null;

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      if (viewTransition) {
        viewTransition.skipTransition();
      }
      return;
    }

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * @param {ViewTransition | null} viewTransition
   * @returns {viewTransition is null}
   */
  function shouldSkipViewTransition(viewTransition) {
    // Safe check to ensure ViewTransition exists in the environment before checking instance
    const isViewTransitionSupported = typeof ViewTransition !== 'undefined' && viewTransition instanceof ViewTransition;
    return !isViewTransitionSupported || isLowPowerDevice() || isMetaAndroidWebView();
  }

  /*
   * We can't import this logic from utilities.js here, but we should keep them in sync.
   */
  function isLowPowerDevice() {
    /* Skip ESLint compatibility check. Number(undefined) <= 2 is always false anyway. */
    /* eslint-disable-next-line compat/compat */
    const hardwareConcurrency = navigator.hardwareConcurrency ? Number(navigator.hardwareConcurrency) : 4;
    const deviceMemory = navigator.deviceMemory ? Number(navigator.deviceMemory) : 4;
    return hardwareConcurrency <= 2 || deviceMemory <= 2;
  }

  function isMetaAndroidWebView() {
    const userAgent = navigator.userAgent || '';
    return /Android/i.test(userAgent) && /(Instagram|FBAN|FBAV|FB_IAB|FB4A|Messenger)/i.test(userAgent);
  }
})();
